import { Platform } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import config from "@utils/config";
import { useFarcasterContext } from "@hooks/useFarcasterContext";

export const useTabBarHeight = () => {
  const insets = useSafeAreaInsets();
  const isIos = Platform.OS === "ios";
  const isAndroid = Platform.OS === "android";
  const { isInMiniApp } = useFarcasterContext();

  // Expo SDK 54 / RN edge-to-edge on Android means the system navigation bar can
  // overlap the app UI. Include the bottom inset so the app can pad content
  // above the navigation bar when needed.
  const androidBottomInset = isAndroid ? insets.bottom : 0;

  if (insets.bottom || !isIos) {
    if (isInMiniApp) {
      return config.UI.tabBarHeight + 20 + androidBottomInset;
    }
    return config.UI.tabBarHeight + androidBottomInset;
  }
  return config.UI.tabBarHeight - 15;
};
